"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'knowledge.preview.title': 'Detalles del Conocimiento',
    'knowledge.preview.edit': 'Editar',
    'knowledge.preview.back': 'Volver a la Lista',
    'knowledge.preview.not_found': 'Entrada de conocimiento no encontrada',
    'knowledge.preview.not_provided': 'No proporcionado',
    'knowledge.preview.no_tags': 'Sin etiquetas',
    'knowledge.preview.no_file': 'Sin archivo adjunto',
    'knowledge.preview.error.load_failed': 'Error al cargar entrada de conocimiento',
    'knowledge.preview.section.basic_info': 'Información Básica',
    'knowledge.preview.section.file_info': 'Información del Archivo',
    'knowledge.preview.section.content': 'Contenido',
    'knowledge.preview.section.used_by_avatars': 'Usado por Avatares',
    'knowledge.preview.section.used_by_professions': 'Usado por Profesiones',
    'knowledge.preview.section.errors': 'Errores',
    'knowledge.preview.content_type.text': 'Texto',
    'knowledge.preview.content_type.file': 'Archivo',
    'knowledge.preview.content_type.link': 'Enlace',
    'knowledge.preview.content_type.google-drive': 'Google Drive',
    'knowledge.preview.rag_status.pending': 'Pendiente',
    'knowledge.preview.rag_status.processing': 'Procesando',
    'knowledge.preview.rag_status.completed': 'Completado',
    'knowledge.preview.rag_status.failed': 'Fallido',
    'knowledge.preview.rag_status.not_indexed': 'No Indexado',
    'knowledge.preview.active.yes': 'Sí',
    'knowledge.preview.active.no': 'No',
    'knowledge.preview.no_avatars_using': 'Ningún avatar está usando actualmente este conocimiento',
    'knowledge.preview.no_professions_using': 'Ninguna profesión está usando actualmente este conocimiento',
};
